import { Component, OnInit } from '@angular/core';
import { concatMap, tap } from 'rxjs/operators';

import { WidgetGroup } from '../widget/config.widget.model';
import { DateRange } from '../widget/date-range.widget.model';
import { WidgetComponentConfig } from '../widget/widget.component';
import { WidgetService } from '../widget/widget.service';

import { TranslationKeyMap } from './pulse.i18n';

@Component({
    selector: 'cmps-pulse',
    templateUrl: './pulse.component.html',
})
export class PulseComponent implements OnInit {
    i18n = TranslationKeyMap;
    dateRanges: DateRange[];
    selectedDateRange: number;
    hasPendingData: boolean;
    groupConfig: WidgetGroup;
    hasDateRangeAwareWidgets: boolean;
    widgetIds: string;
    configs: WidgetComponentConfig[];

    constructor(private readonly _widgetService: WidgetService) {
        this.selectedDateRange = 0;
        this.widgetIds = '';
    }

    ngOnInit(): void {
        this.hasPendingData = true;
        this._widgetService
            .dateRanges()
            .pipe(
                tap((data) => {
                    this.dateRanges = data;
                    this._widgetService.dateRange.next(this.dateRanges[0]);
                }),
                concatMap(() =>
                    this._widgetService.widgetConfigurations().pipe(
                        tap((data) => {
                            this.groupConfig = data;
                            const configWidgets =
                                this.groupConfig.configurations
                                    .map((value) => ({
                                        config: value,
                                        widget: this._widgetService.widgets.find(
                                            (w) => w.typeId === value.typeId,
                                        ),
                                    }))
                                    .filter((value) => {
                                        if (!value.widget) {
                                            console.log(
                                                'widget not found',
                                                value.config.typeId,
                                            );
                                            return false;
                                        }
                                        return true;
                                    });
                            this.hasDateRangeAwareWidgets = configWidgets.some(
                                (value) => value.widget.isDateRangeAware,
                            );
                            this.configs = configWidgets.map((value) => {
                                const { config, widget } = value;
                                const id = `cmpsWidget${(
                                    Math.random() * 100000
                                ).toFixed()}`;
                                return {
                                    id,
                                    header: config.title,
                                    component: widget.component,
                                    config,
                                    noEncapsulate: widget.noEncapsulate,
                                };
                            });
                            this.widgetIds = this.configs
                                .map((value) => value.id)
                                .join(' ');
                        }),
                    ),
                ),
            )
            .subscribe(
                () => null,
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
                // eslint-disable-next-line no-return-assign
                () => (this.hasPendingData = false),
            );
    }

    informWidgets($event): void {
        this.selectedDateRange = $event;
        this._widgetService.dateRange.next(
            this.dateRanges[this.selectedDateRange],
        );
    }
}
